<div [hidden]="consulta">
  <div class="row">
      <div class="col-lg-12" style="padding: 0px;">
          <section class="widget">
              <!-- título -->
              <header>
                  <h3> {{sistemaService.NombrePantallaActual}}: {{accion.accion}}</h3>
              </header>
          </section>
          <div class="divisor8"></div>
          <section class="widget">

              <div class="row">
              <div class="col-lg-12" style="padding: 0px">
                  <div class="row">
                      <div class="col-lg-3 col-md-3 col-sm-12 col-12">
                          <div class="panelBotonesFiltro">
                              <button class="boton botonSM filledBlanco" (click)="envioEmail()">
                              <span> {{'Enviar recordatorio a pendientes'}}</span>
                          </button>
                          </div>
                      </div>

                  </div>

              <!-- tabla -->
              <div *ngIf="accion.accionid != 1">
               <!-- datos -->
                  <dx-data-grid
                      (onOptionChanged)="sistemaService.CambiarPaginacionTabla($event)"
                      id="tabla"
                      [columnAutoWidth]="true"
                      [dataSource]="listaacuerdopendiente"
                      [noDataText]="'Sin Datos'"
                      [showColumnHeaders]="true"
                      (onExporting)="onExporting($event)"
                      >
                      <dxo-export [enabled]="true" [fileName]="sistemaService.NombrePantallaActual" matTooltip="Todo" ></dxo-export>

                      <dxo-search-panel
                          [visible]="true"
                          [width]="240"
                          placeholder="{{'Buscar' | translate}}">
                      </dxo-search-panel>

                      <dxo-paging [pageSize]="0"></dxo-paging>
                      <!--<dxo-scrolling mode="virtual" [useNative]="false" [showScrollbar]="'always'"></dxo-scrolling>-->

                    <dxo-header-filter [visible]="true"></dxo-header-filter>
                    <dxo-group-panel [visible]="true"></dxo-group-panel>
                      <dxo-pager
                          [visible]="false"
                          [allowedPageSizes]="sistemaService.tablaPaginacionPaginaSize"
                          [displayMode]="sistemaService.tablaPaginacionModo"
                          [showPageSizeSelector]="sistemaService.tablaPaginacionSelector"
                          [showInfo]="sistemaService.tablaPaginacionInfo"
                          [showNavigationButtons]="sistemaService.tablaPaginacionNavegacion">
                      </dxo-pager>
                      <dxi-column
                        dataField="nombrejefe"
                        caption="Jefe"
                        [groupIndex]="0"
                        groupCellTemplate="groupCellTemplateColaborador"
                        [autoExpandGroup]="true">
                    </dxi-column>
                      <dxi-column
                          dataField="nombresubordinado"
                          caption="Persona evaluada">
                      </dxi-column>
                      <dxi-column
                          dataField="puestosubordinado"
                          caption="Puesto">
                      </dxi-column>
                      <dxi-column
                          dataField="firma"
                          caption="Estatus acuerdo">
                      </dxi-column>
                      <div *dxTemplate="let cellInfocolaborador of 'groupCellTemplateColaborador'">
                        <div class="accionEncabezado">
                            <div class="accionEncabezado__titulo">
                                {{cellInfocolaborador.value}}
                            </div>
                            <div class="accionEncabezado__acciones">
                                <span>{{resumenJefe(cellInfocolaborador.value).avance}}% ({{resumenJefe(cellInfocolaborador.value).firmados}} de {{resumenJefe(cellInfocolaborador.value).total}} terminados)</span>
                            </div>
                        </div>
                    </div>
                  </dx-data-grid>

              </div>

              </div>
              </div>
              <div class="divisor20"></div>
              <div class="row margen" >
                  <div class="col-12">
                      <div class="panelBotonesFiltro">
                          <button matTooltip="Cancelar" class="boton botonSM filledBlanco"
                          (click)="Salir()">
                          <span> {{'Cerrar'}}</span>
                      </button>
                      </div>
                  </div>
              </div>
          </section>
      </div>
  </div>
</div>
